import { ICloneable } from '../../../contracts/cloneable.js';
import { IDataComparable } from '../../../contracts/data-comparable.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { SerializedData } from '../../dto/data-model.js';

export class CameraConstraints implements IDataComparable, ICloneable {
  static readonly DEFAULT_CAMERA_CONSTRAINTS = new CameraConstraints(
      -36,
      36,
      -36,
      36,
      15,
      60,
  );

  constructor(
    public readonly minX: number,
    public readonly maxX: number,
    public readonly minY: number,
    public readonly maxY: number,
    public readonly minViewportScale: number,
    public readonly maxViewportScale: number,
  ) {
    if(this.minX > this.maxX) {
      throw new Error('minX must be less than or equal to maxX');
    }

    if(this.minY > this.maxY) {
      throw new Error('minY must be less than or equal to maxY');
    }

    if(this.minViewportScale > this.maxViewportScale) {
      throw new Error('minViewportScale must be less than or equal to maxViewportScale');
    }

    if(minViewportScale <= 0) {
      throw new Error('minViewportScale must be greater than 0');
    }

    if(maxViewportScale <= 0) {
      throw new Error('maxViewportScale must be greater than 0');
    }
  }

  static fromJson(map: SerializedData): CameraConstraints {
    return new CameraConstraints(
        MapUtils.getNumber(map, 'minX'),
        MapUtils.getNumber(map, 'maxX'),
        MapUtils.getNumber(map, 'minY'),
        MapUtils.getNumber(map, 'maxY'),
        MapUtils.getNumber(map, 'minViewportScale'),
        MapUtils.getNumber(map, 'maxViewportScale'),
    );
  }

  toJson(): SerializedData {
    return {
      minX: this.minX,
      maxX: this.maxX,
      minY: this.minY,
      maxY: this.maxY,
      minViewportScale: this.minViewportScale,
      maxViewportScale: this.maxViewportScale,
    };
  }

  clone(): this {
    return new CameraConstraints(
        this.minX,
        this.maxX,
        this.minY,
        this.maxY,
        this.minViewportScale,
        this.maxViewportScale,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.minX === this.minX &&
        other.maxX === this.maxX &&
        other.minY === this.minY &&
        other.maxY === this.maxY &&
        other.minViewportScale === this.minViewportScale &&
        other.maxViewportScale === this.maxViewportScale;
  }
}
